import React from 'react';
import PageLegale from './PageLegale';

// Le texte de cette page vit dans contenu/<langue>.js : il suit désormais le
// sélecteur de langue, comme le reste du site.
export default function LegalNotice() {
  return <PageLegale cle="mentions" />;
}
